import { render } from "./ListDataCuti.vue?vue&type=template&id=ff720a32"
import script from "./ListDataCuti.vue?vue&type=script&lang=js"
export * from "./ListDataCuti.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__